/*
* @TagDevice.vue
* @Description 标签管理组件
* @Author jsh
* @Date 2021/6/17
*/
/* HTML */
<template>
    <div class="view-tree-table">
        <!-- router-title-box start -->
		<div class="router-title-box" >
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">定位标签</div>
			</div>
		</div>
		<!-- router-title-box end -->
        <UwbTagTable ref="uwbTagTable" />
    </div>
</template>

/* JS */
<script>
	// 组件 UWB标签列表
	import UwbTagTable from "@/components_pages/Device/UwbTagTable";
	
    export default {
        /**
         * 组件名
         */
        name: "TagDevice",
        /**
         * 引用组件
         */
        components: {
            // 组件 UWB标签列表
            UwbTagTable
        },
        data() {
            return {
            }
        },
        mounted(){
        },
        methods: {
            /**
             * @Des 关闭路由
             * @Auth
             * @Date
             */
            closeRouter () {
                // 跳转到 首页
                this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
            },// closeRouter
            
        }// methods
        
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/system-manager/device/TagDevice.vue